import { useRef, useEffect } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import LineTableRow from './LineTableRow';
import Groups3Icon from '@mui/icons-material/Groups3';
import TimelineIcon from '@mui/icons-material/Timeline';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ShapeLineIcon from '@mui/icons-material/ShapeLine';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import { useCurrentHash } from '../hooks/hashs/useCurrentHash';
import { useLayoutStore } from '../hooks/screen/useLayoutStore';
import { useScreenStore } from '../stores/useScreenStore';

const LineTableView = ({lines, endOfListRef, resetScrollKey}) => {

  const containerRef = useRef(null);

  const { hashColor } = useCurrentHash();

  const isCompactMode = useLayoutStore(
    state => state.isCompactMode
  );

  const monitorMode = useScreenStore(state => state.monitorMode);

  useEffect(() => {

    containerRef.current?.scrollTo({
      top: 0,
      behavior: 'auto'
    });

  }, [resetScrollKey]);

  return (
  
    <TableContainer
      data-compact-scroll-ignore
      ref={containerRef}
      sx={{
        flex: 1,
        overflow: 'auto',
        pl: (monitorMode === 1 && isCompactMode) ? 7 : 0
      }}
    >

      <Table stickyHeader>

        <TableHead
          sx={(theme) => ({
            '& .MuiTableCell-root': {
              backgroundColor:
                theme.palette[hashColor]?.main,
              color: theme.palette.getContrastText(
                theme.palette[hashColor]?.main
              ),
              fontWeight: 600,
              borderTop: 1,
              borderTopColor: theme.palette.getContrastText(
                theme.palette[hashColor]?.main
              ),
            }
          })}
        >
          <TableRow>

            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <TimelineIcon sx={{ fontSize: 20 }} />
                <span>LINHA</span>
              </div>
            </TableCell>

            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <ArrowCircleLeftIcon sx={{ fontSize: 20 }}/>
                <span>SENTIDO</span>
                <ArrowCircleRightIcon sx={{ fontSize: 20 }}/>
              </div>
            </TableCell>

            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <Groups3Icon sx={{ fontSize: 20 }} />
                <span>CLIENTE</span>
              </div>
            </TableCell>

            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <WarehouseIcon sx={{ fontSize: 20 }} />
                <span>UNIDADE</span>
              </div>
            </TableCell>

            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <WbTwilightIcon sx={{ fontSize: 20 }} />
                <span>TURNO</span>
              </div>
            </TableCell>
                
            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <ShapeLineIcon sx={{ fontSize: 20 }} />
                <span>CÓDIGO</span>
              </div>
            </TableCell>

            <TableCell align="center">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4
                }}
              >
                <AddRoadIcon sx={{ fontSize: 20 }} />
                <span>KM</span>
              </div>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>

          {lines.map(line => (
            <LineTableRow
              key={line.CODIGO_INTEGRACAO}
              line={line}
            />
          ))}

          <TableRow>
            <TableCell colSpan={999}>
              <div
                ref={endOfListRef}
                style={{ height: 10 }}
              />
            </TableCell>
          </TableRow>

        </TableBody>

      </Table>

    </TableContainer>
  );
};

export default LineTableView;